import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './whatsapp.less';
import './whatsapp-en.less';
import './whatsapp.theme.less';

export interface WhatsappProps {
  topicName: string;
  topicSettings: any[];
}

export function WhatsApp(props: WhatsappProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
